import React from "react";

/* Import Boostrap */
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

const ListWithIcons = ({ translate, props }) => {
        var elements =  Object.keys(props.icons).map(function(keyName, keyIndex) {
            return (
                <a key={keyName} href={keyName === 'email'? 'mailto:'+props.icons[keyName] : props.icons[keyName]} target="_blank" rel="noopener noreferrer">
                    <i className={"icon-"+keyName}></i>
                </a>
            )
        }) 
      return (
            <li>
                {elements}
            </li>
      )
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(ListWithIcons);               
               
               
               
               
               
               



// WEBPACK FOOTER //
// ./src/components/lists/list-icons.jsx